import { useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { CellDropdownItem } from "@idw-types/common";
import { LabelWidthTypes } from "@enums/label-width-types";
import { TableCellDropdownItem } from "./table-cell-dropdown-item/table-cell-dropdown-item";
import styles from "./table-cell-with-dropdown.less";

type TableCellWithDropdownProps = {
    value: string | React.ReactNode;
    dropdownText: string;
    items: Array<CellDropdownItem>;
    uniqueId: string;
    disabled?: boolean;
    className?: string;
};

export const TableCellWithDropdown = (props: TableCellWithDropdownProps) => {
    const {
        value,
        dropdownText,
        items,
        className = "",
        disabled,
        uniqueId
    } = props;

    const handleClick = (event: MouseEvent) => {
        const toggleElement = document.getElementById(`dropdown-toggle-${uniqueId}`);
        if (toggleElement && event.target === toggleElement) {
            const menuElement = document.getElementById(`dropdown-menu-${uniqueId}`);
            if (menuElement) {
                menuElement.scrollTo(0, 0);
            }
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick)
        }
    }, []);

    return (
        <div className={styles.cellWithDropdown}>
            <span>{value}</span>
            {items.length > 0 && (
                <Dropdown id={`dropdown-${uniqueId}`} className={`${styles.dropdownButton} ${className}`}>
                    <Dropdown.Toggle
                        title={"Open dropdown"}
                        //@ts-ignore
                        size={LabelWidthTypes.EXTRA_SMALL}
                        disabled={disabled}
                        id={`dropdown-toggle-${uniqueId}`}
                        variant={"outline-primary"}
                    >
                        {dropdownText}
                    </Dropdown.Toggle>
                    <Dropdown.Menu id={`dropdown-menu-${uniqueId}`} className={styles.dropdownMenu}>
                        {items.map(item => {
                            if (item.isHeader) {
                                return (
                                    <Dropdown.Header
                                        key={`dropdown-menu-header-${item.title}`}
                                        className={styles.dropdownHeader}
                                        title={item.title}
                                    >
                                        {item.title}
                                    </Dropdown.Header>
                                );
                            } else {
                                return (
                                    <TableCellDropdownItem
                                        item={item}
                                        key={`dropdown-menu-item-${item.title}`}
                                    />
                                );
                            }
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            )
            }
        </div >
    );
};